export const ALLOW_SELECT_NO_PRODUCT = true
export const AUTO_SELECT_PRODUCT = false
export const RESIZABLE = { resize: 'both', overflow: 'auto' } as const
